import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import connect from '../views/axios/axios.auth';
import Card from './card.component';
import Modal from './modal/modal.component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const customStyles = {
rows: {
  style: {
    minHeight: '72px', // override the row height
  }
},
headCells: {
  style: {
    paddingLeft: '8px', // override the cell padding for head cells
    paddingRight: '8px',
  },
},
cells: {
  style: {
    paddingLeft: '8px', // override the cell padding for data cells
    paddingRight: '8px',
  },
},
};

const ClienteComponentModal = ({ onSelected, visibleOpen, onClose }) => {

  const [listado, setListado] = useState([]);
  const [pending, setPending] = useState(true);
  const [visible, setVisible] = useState(visibleOpen);

  useEffect(() => {
    listadoClientes();
  },[])

  useEffect(() => {
    setVisible(visibleOpen);
  },[visibleOpen])

  const clientesSeleccionados = (row) => {
    onSelected(row);
  }

  const listadoClientes = () => {
    connect.get(`/cliente/`)
    .then((response) => {
      setListado(response.data.clientes);
      setPending(false);
    })
  }

  const columnsClientes = [
    {
      name: 'Rut',
      selector: 'rut',
      sortable: true,
    },
    {
      name: 'Nombre completo',
      selector: 'name',
      sortable: true,
    },
    {
      name: 'Seleccionar',
      sortable: false,
      right: true,
      cell: row => (
        <button 
          onClick={() => clientesSeleccionados(row)}
          type="button"
          className="btnx btnx-warn m-1"
        >
            <FontAwesomeIcon icon={faCheck} />
        </button>
      )
    },
  ];

  
  return (
    <>
    <Modal show={visible}>
      <Card>
          <h3>Clientes</h3>
          <DataTableExtensions
           columns={columnsClientes}
           data={listado}
           export={false}
           print={false}
           filterPlaceholder="Buscar cliente"
          >
              <DataTable
              noHeader={true}
              customStyles={customStyles}
              dense={true}
              pagination={true}
              paginationPerPage={5}
              progressPending={pending}
              progressComponent={
                <h3>Cargando...</h3>
              }
              noDataComponent={"No existen datos asociados a la busqueda."}
            />
          </DataTableExtensions>
          <button 
              onClick={() => onClose()}
              type="button"
              className="btnx btnx-warn mr-1"
              >
                  Cerrar
          </button>
        </Card>
      </Modal>
   </>
  )
}

export default ClienteComponentModal;